import Keycloak from 'keycloak-js';

import { config } from '@/shared/lib/config';

const keycloakUrl = config.KEYCLOAK_URL;
const realm = config.KEYCLOAK_REALM;
const clientId = config.KEYCLOAK_CLIENT_ID;

const keycloak = new Keycloak({
  url: keycloakUrl,
  realm: realm,
  clientId: clientId,
});

export default keycloak;
